import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setToast } from "../../redux/reducers/toast_message";

const Login = () => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const [isLoginFailed, setisLoginFailed] = useState(false);
  const [isRemember, setIsRemember] = useState(false);
  const [isSecure, setIsSecure] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem("atkn") || localStorage.getItem("atkn")) {
      nav("/dashboard");
    }
    if (isLoginFailed) {
      setTimeout(() => {
        setisLoginFailed(false);
      }, 3000);
    }
  }, [isLoginFailed]);

  const handleLogin = async () => {
    let data = JSON.stringify({
      email: emailInputRef.current.value,
      password: passwordInputRef.current.value,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((res) => {
        if (res.data.status == 200) {
          if (isRemember) {
            localStorage.setItem("atkn", res.data.access_token);
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("email", res.data.data.email);
          } else {
            sessionStorage.setItem("atkn", res.data.access_token);
            sessionStorage.setItem("name", res.data.data.name);
            sessionStorage.setItem("email", res.data.data.email);
          }
          nav("/dashboard");
        } else {
          dispatch(setToast({ type: "ERROR", message: res.data.message }));
          nav("/");
        }
      })
      .catch((e) => {
        setisLoginFailed(true);
        nav("/");
      });
  };

  return (
    <div className="flex h-dvh items-center justify-center bg-base-300">
      <div className="md:w-80 md:h-96 bg-base-100 rounded-xl p-5 flex flex-col items-center justify-between">
        <div className="flex flex-col items-center gap-1">
          <p className="text-3xl text-baseColor font-medium">Cleva POS</p>
          <p className="text-sm text-disable font-light">
            Your future point of sales
          </p>
        </div>
        <div className="form-control w-full">
          <div className="flex flex-col gap-5">
            <input
              type="email"
              placeholder="E-mail address or phone number"
              className="input input-bordered focus:border-2 focus:outline-none focus:border-baseColor text-neutral-700"
              ref={emailInputRef}
            />
            <label className="input input-bordered flex items-center gap-2 focus-within:outline-none">
              <input
                type={isSecure ? "password" : "text"}
                className="grow text-neutral-700"
                ref={passwordInputRef}
                placeholder="Password"
              />
              <a
                onClick={() => setIsSecure(!isSecure)}
                className="hover:cursor-pointer"
              >
                {isSecure ? (
                  <IoEye className="text-neutral-700 text-lg" />
                ) : (
                  <IoMdEyeOff className="text-neutral-700 text-lg" />
                )}
              </a>
            </label>
          </div>

          <div className="flex justify-between items-center pt-2">
            <div className="flex gap-2">
              <input
                type="checkbox"
                checked={isRemember}
                onChange={() => setIsRemember(!isRemember)}
              />
              <p className="text-sm text-neutral-700">Remember me</p>
            </div>

            <p className="hover:cursor-pointer text-sm text-baseColor font-medium">
              Forgot password?
            </p>
          </div>
        </div>

        <button
          onClick={handleLogin}
          className="btn btn-active bg-baseColor w-full text-base-100 hover:bg-baseColor"
        >
          Sign in
        </button>
      </div>
    </div>
  );
};

export default Login;
